module.exports = __webpack_public_path__ + "static/media/Panton-SemiBold.23907e32.woff";